var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow",attrs:{"id":"app"}},[_c('Viewpage'),_c('div',{staticClass:"dropdown-inners"},[_c('div',{ref:"dropdownOverlays"}),_c('div',{ref:"dropdownMenus"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }